import { useMemo } from "react";

import { useSelector } from "react-redux";

import CountryService from "app/services/CountryService";

import CrmEnrichmentJobReviewCredits from "../../../components/wizard/CrmEnrichmentJobReviewCredits";
import CrmEnrichmentJobReviewWizardStep from "../../../components/wizard/CrmEnrichmentJobReviewWizardStep";
import { selectJobState, selectMappings, selectWizardFilters } from "../../../store/selectors";
import { mappingsToPriceFields } from "../../../utils/job";
import useSfEnrichmentJobPriceQuery from "../query/queries/useSfEnrichmentJobPriceQuery";

type Props = {
    onMoveToStep: (step: number) => void;
};

const SfJobReviewWizardStepContainer = (props: Props) => {
    const currentJobState = useSelector(selectJobState);
    const wizardFilters = useSelector(selectWizardFilters);
    const mappings = useSelector(selectMappings);

    const priceFields = useMemo(() => mappingsToPriceFields(mappings), [mappings]);

    const { data, isLoading } = useSfEnrichmentJobPriceQuery(priceFields);

    return (
        <CrmEnrichmentJobReviewWizardStep
            {...props}
            {...wizardFilters}
            selectedJobType={currentJobState.jobType}
            selectedJobObject={currentJobState.jobObject}
            selectedCountry={CountryService.getCountryById(currentJobState.countryId)}
            selectedJobRefreshPeriod={currentJobState.refreshPeriod}
            selectedEnrichmentSource={currentJobState.enrichmentSource}
            mappingsCount={mappings.length}
        >
            <CrmEnrichmentJobReviewCredits
                priceData={data}
                isLoading={isLoading}
            />
        </CrmEnrichmentJobReviewWizardStep>
    );
};

export default SfJobReviewWizardStepContainer;
